import { render, staticRenderFns } from "./OwnerPriceDetails.vue?vue&type=template&id=50d5dbb9&"
import script from "./OwnerPriceDetails.vue?vue&type=script&lang=js&"
export * from "./OwnerPriceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports